import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { API_OPTIONS } from "../utils/constants";
import { addMovieTrailerVideo } from "../utils/moviesSlice";

const useMovieTrailer = (movieId) => {
  const dispatch = useDispatch();
  const movieTrailerVideo = useSelector(store => store.movies.movieTrailerVideo)

  const getTrailer = async () => {
    const data = await fetch(`https://api.themoviedb.org/3/movie/${movieId}/videos?language=en-US`, API_OPTIONS)
    const json = await data.json();

    const filterData = json.results.filter(result => result.type === "Trailer");
    const trailer = filterData.length ? filterData[0] : json.results[0];
    dispatch(addMovieTrailerVideo(trailer));
  }

  useEffect(() => {
    !movieTrailerVideo && getTrailer();
  }, [])
}

export default useMovieTrailer;